import { create } from 'zustand';

import { SiteTechnician } from 'api/clients/types';

interface DeleteTechnicianModalStore {
  isOpen: boolean;
  isDeleteOnObjectModal: boolean;
  isDeleteOnClientModal: boolean;
  objectSlug: string;
  siteTechnician: SiteTechnician | null;
  open: (
    objectSlug: string,
    siteTechnician: SiteTechnician,
    isDeleteOnObjectModal: boolean,
    isDeleteOnClientModal: boolean,
  ) => void;
  close: () => void;
}

export const useDeleteTechnicianModalStore = create<DeleteTechnicianModalStore>(set => ({
  isOpen: false,
  isDeleteOnObjectModal: false,
  isDeleteOnClientModal: false,
  objectSlug: '',
  siteTechnician: null,
  open: (
    objectSlug: string,
    siteTechnician: SiteTechnician,
    isDeleteOnObjectModal: boolean,
    isDeleteOnClientModal: boolean,
  ) => set({ isOpen: true, objectSlug, siteTechnician, isDeleteOnObjectModal, isDeleteOnClientModal }),
  close: () =>
    set({
      isOpen: false,
      objectSlug: '',
      siteTechnician: null,
      isDeleteOnObjectModal: false,
      isDeleteOnClientModal: false,
    }),
}));
